let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cS8nd")).then(() => parcelRequire('c83ZD'));